const userModel = {
  _id: '',
  firstName: '',
  lastName: '',
  email: '',
  additionalInformation: {},
  digitalAccount: {},
  bankAccount: {},
  cards: {},
  address: {},
  avatar: {},
  description: '',
  userType: '',
  social: [],
  typeRegistration: '',
  businessName: '',
  corporateName: '',
  documents: []
}

export const user = {
  namespaced: true,
  state: {
    data: userModel,
    loading: true,
    registerOK: true
  },
  actions: {
    async get({ commit }, payload ) {
      const data = payload.data.user
      commit('dataUser', data);
    },
    clear({ commit }) {
      commit('clearUserData');
    },
     registerStatus({ commit }, payload) {
       commit('registerStatus', payload)
     }
  },
  mutations: {
    dataUser(state, data) {
      state.data = data
      state.loading = false
    },
    clearUserData(state) {
      state.data = userModel
    },
     registerStatus(state, data) {
        state.registerOK = data
     },
  },
   getters: {
      getUserData (state) {
         return state.data
      }
   }
};
